import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

const VerifyEmailFailed: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <Result
        status='warning'
        title='Email Verification Failed'
        subTitle='Email verification failed. Please contact Administrator.'
        extra={
          <Button type='primary' onClick={() => navigate('/')}>
            Back Home
          </Button>
        }
      />
    </>
  );
};

export default VerifyEmailFailed;
